import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';
function CustomPage(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? colors.neutral700 : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.345 10.528c.479 0 .868.389.868.868v1.013a6.819 6.819 0 0 1 1.69.579l.512-.512a1.158 1.158 0 0 1 1.638 1.637l-.513.513c.266.535.461 1.103.58 1.69h1.012a.868.868 0 1 1 0 1.736h-1.013a6.841 6.841 0 0 1-.579 1.69l.513.512a1.158 1.158 0 0 1-1.638 1.638l-.512-.513a6.834 6.834 0 0 1-1.69.58v1.012a.868.868 0 1 1-1.737 0v-1.013a6.83 6.83 0 0 1-1.69-.579l-.512.513a1.158 1.158 0 1 1-1.637-1.638l.512-.512a6.833 6.833 0 0 1-.579-1.69h-1.013a.868.868 0 1 1 0-1.736h1.013a6.832 6.832 0 0 1 .579-1.69l-.512-.513a1.158 1.158 0 1 1 1.637-1.637l.513.512a6.815 6.815 0 0 1 1.69-.579v-1.013c0-.48.388-.868.867-.868Zm3.06-8.689c1.27 0 2.594 1 2.594 2.334L22 11.5c-1-1-1.035-1.113-2-1.454V9H3v8.839h5.765c0 .908.156 1.309.442 2.119L3.3 19.957C2.03 19.957 1 18.875 1 17.54V4.255C1 2.92 2.03 1.839 3.3 1.839h16.105Zm-3.06 13.126a2.218 2.218 0 1 0 0 4.437 2.218 2.218 0 0 0 0-4.437ZM20 4H3v3.016h17V4Z",
    fill: color
  }));
}
export default CustomPage;